import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100%",
    padding: "22px 18px 26px",
    overflowY: "auto",
    background: "#f4f7f8",
    [theme.breakpoints.down("sm")]: { padding: "14px 18px" },
  },
  pageHeader: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, marginBottom: 18 },
  pageTitle: { color: "#14253d", fontSize: 27, lineHeight: 1.2, fontWeight: "800 !important" },
  pageSubtitle: { color: "#738092", fontSize: 14, marginTop: 5 },
  addButton: {
    backgroundColor: "#087b59 !important", color: "#fff !important", borderRadius: 8,
    padding: "8px 14px", textTransform: "none", fontSize: 12, fontWeight: 700,
    boxShadow: "none", "&:hover": { backgroundColor: "#06694c !important", boxShadow: "none" },
  },
  headerActions: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
  secondaryButton: { borderColor: "#cfd8e0 !important", color: "#214d43 !important", borderRadius: 8, padding: "7px 14px", textTransform: "none", fontSize: 12, fontWeight: 700 },
  catalogForm: { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 12, "& .MuiInputBase-root": { fontSize: 13 }, [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" } },
  catalogWide: { gridColumn: "1 / -1" },
  catalogList: { display: "flex", flexDirection: "column" },
  catalogRow: {
    display: "grid", gridTemplateColumns: "56px minmax(0,1fr) auto 40px", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid #edf1f3",
    "& > img": { width: 56, height: 40, objectFit: "contain" }, "& > .MuiSvgIcon-root": { justifySelf: "center", color: "#9aa5b1", fontSize: 30 },
  },
  catalogInfo: { minWidth: 0 },
  catalogName: { color: "#1b2c40", fontSize: "14px !important", fontWeight: "700 !important", "& span": { marginLeft: 6 } },
  catalogMeta: { color: "#687484", fontSize: "12px !important", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  catalogPrice: { display: "flex", flexDirection: "column", alignItems: "flex-end", "& b": { color: "#1b2c40", fontSize: 13 }, "& span": { color: "#687484", fontSize: 11.5 } },
  statsGrid: { display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 10, marginBottom: 16,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  statCard: { display: "flex", alignItems: "center", gap: 12, minHeight: 74, padding: "12px 15px", borderRadius: 10, border: "1px solid transparent" },
  availableCard: { background: "#edf9f3", borderColor: "#d7f0e3" },
  reservedCard: { background: "#fbf4e9", borderColor: "#f2e7d4" },
  deliveredCard: { background: "#eef6fc", borderColor: "#dceaf7" },
  statIcon: { width: 38, height: 38, flex: "0 0 38px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 10, "& .MuiSvgIcon-root": { fontSize: 21 } },
  availableIcon: { background: "#d9f2e5", color: "#0b805d" },
  reservedIcon: { background: "#ffebce", color: "#dc7610" },
  deliveredIcon: { background: "#dceefe", color: "#2374c7" },
  statValue: { color: "#15253b", fontSize: 23, fontWeight: "800 !important", lineHeight: 1.15 },
  statLabel: { color: "#647386", fontSize: 11, marginTop: 3 },
  contentGrid: { display: "grid", gridTemplateColumns: "minmax(0, 2.15fr) minmax(275px, .95fr)", gap: 12, alignItems: "stretch",
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
  },
  listPanel: { minWidth: 0, background: "#fff", border: "1px solid #e5ebee", borderRadius: 11, overflow: "hidden", boxShadow: "0 2px 7px rgba(24,45,60,.035)" },
  panelHeader: { minHeight: 52, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "9px 12px", borderBottom: "1px solid #edf1f3" },
  panelTitle: { color: "#1b2c40", fontSize: 17, lineHeight: 1.3, fontWeight: "800 !important" },
  listTools: { display: "flex", alignItems: "center", gap: 8, minWidth: 0, flexWrap: "wrap", justifyContent: "flex-end" },
  searchField: { width: 290, "& .MuiOutlinedInput-root": { height: 36, borderRadius: 7, fontSize: 12, background: "#fbfcfd" }, "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e7eb" }, "& .MuiInputAdornment-root": { color: "#7b8794", marginRight: 5 }, "& .MuiSvgIcon-root": { fontSize: 18 }, "& .MuiInputBase-input": { padding: "7px 0" },
    [theme.breakpoints.down("xs")]: { width: "100%" },
  },
  filterField: { width: 180, "& .MuiOutlinedInput-root": { height: 36, borderRadius: 7, fontSize: 13, background: "#fbfcfd" }, "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e7eb" },
    [theme.breakpoints.down("xs")]: { width: "100%" },
  },
  refreshButton: { minWidth: 32, width: 32, height: 32, padding: 0, color: "#607080", borderRadius: 7, "& .MuiSvgIcon-root": { fontSize: 18 } },
  tableWrapper: {
    width: "100%",
    background: "#fff",
    borderRadius: "0 0 11px 11px",
    overflow: "hidden",
  },
  dataGridTable: {
    width: "100%",
    border: 0,
    color: "#344256",
    "& .MuiDataGrid-columnHeaders": {
      background: "#edf2f5",
      minHeight: "48px !important",
      maxHeight: "48px !important",
      borderBottom: "1px solid #e1e8ec",
    },
    "& .MuiDataGrid-columnHeader": { paddingTop: 8, paddingBottom: 8 },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "#536276",
      fontSize: 14,
      fontWeight: 700,
    },
    "& .MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      paddingTop: 8,
      paddingBottom: 8,
      borderBottomColor: "#edf1f3",
      fontSize: 14,
    },
    "& .MuiDataGrid-row:hover": { backgroundColor: "#f7faf9" },
    "& .MuiDataGrid-footerContainer": { borderTop: "1px solid #e9eef0" },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": { height: 8 },
    },
    "& .stock-empty-state": {
      display: "flex",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
      color: "#778596",
      fontSize: 14,
    },
  },
  modelCell: { fontWeight: 700, color: "#27384c" },
  vinCell: { maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", color: "#657387" },
  dossierCell: { maxWidth: 135, overflow: "hidden", textOverflow: "ellipsis", color: "#627286" },
  statusBadge: { display: "inline-flex", alignItems: "center", padding: "8px 12px", borderRadius: 6, fontSize: 13, lineHeight: 1, fontWeight: 700 },
  statusDisponible: { color: "#08734e", background: "#dcf3e6" },
  statusRéservé: { color: "#ae6200", background: "#fff0d5" },
  statusLivré: { color: "#2168aa", background: "#e1f0ff" },
  statusIndisponible: { color: "#687484", background: "#edf0f2" },
  statusBloqué: { color: "#b42318", background: "#fde2e0" },
  readyText: { color: "#08734e", fontWeight: 700 },
  missingText: { color: "#ae6200", fontWeight: 700, cursor: "help" },
  emptyCell: { height: 125, textAlign: "center", color: "#778596" },
  entryPanel: { display: "flex", flexDirection: "column", minWidth: 0, padding: 15, border: "1px solid #e5ebee", borderRadius: 11, background: "#fff", boxShadow: "0 2px 7px rgba(24,45,60,.035)" },
  entryHeading: { marginBottom: 10 },
  entryDescription: { color: "#738092", fontSize: 12, marginTop: 4 },
  entryIllustration: { minHeight: 84, display: "flex", alignItems: "center", justifyContent: "center", margin: "5px 0 11px", borderRadius: 9, color: "#16805f", background: "linear-gradient(135deg, #eff9f4, #f4f8fa)", "& .MuiSvgIcon-root": { fontSize: 43 } },
  entryNote: { color: "#718093", fontSize: 12, lineHeight: 1.6, marginBottom: 13 },
  entryDialog: {
    "& .MuiDialog-paper": { borderRadius: 12, overflow: "hidden" },
  },
  entryDialogTitle: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
    padding: "17px 22px", borderBottom: "1px solid #e9eef0",
    "& .MuiIconButton-root": { color: "#667587" },
  },
  dialogTitleText: { color: "#17283d", fontSize: 18, fontWeight: 800 },
  dialogSubtitle: { color: "#718093", fontSize: 12, marginTop: 3 },
  entryDialogContent: { padding: "20px 22px !important" },
  entryDialogActions: {
    padding: "12px 22px 18px !important", gap: 8,
    "& .MuiButton-root": { minWidth: 108 },
    "& .MuiButton-root:last-child": { width: "auto" },
  },
  cancelButton: { color: "#5f6f80", textTransform: "none", fontWeight: 700 },
  entryForm: {
    display: "flex", flexDirection: "column", gap: 10, marginTop: 4,
    "& .MuiInputBase-root": { fontSize: 12, borderRadius: 7, background: "#fff" },
    "& .MuiOutlinedInput-input": { padding: "9px 10px" },
    "& .MuiSelect-select": { padding: "9px 10px" },
    "& input::placeholder": { color: "#8995a3", opacity: 1 },
  },
  fieldGroup: { display: "flex", flexDirection: "column", gap: 4, minWidth: 0 },
  fieldRow: { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 10 },
  fieldHint: { color: "#718093", fontSize: 11, marginTop: -4 },
  fieldLabel: { color: "#26364b", fontSize: 11, lineHeight: 1.3, fontWeight: 700, "& span": { color: "#df5148" } },
  dangerButton: { minHeight: 38, color: "#fff !important", backgroundColor: "#b42318 !important", borderRadius: 7, textTransform: "none", fontWeight: 700, fontSize: 12, boxShadow: "none", "&:hover": { backgroundColor: "#912018 !important", boxShadow: "none" } },
  dangerMenuItem: { color: "#b42318 !important" },
  actionDescription: { color: "#526174", fontSize: 13, lineHeight: 1.5 },
  missingBox: {
    padding: "10px 12px", borderRadius: 8, background: "#fff7e8", border: "1px solid #f6dfb6", marginBottom: 10,
    "& ul": { margin: "6px 0 4px", paddingLeft: 18, color: "#7a4a00", fontSize: 13 },
    "& .MuiFormControlLabel-label": { fontSize: 13 },
  },
  readyBox: { padding: "10px 12px", borderRadius: 8, background: "#edf9f3", border: "1px solid #d7f0e3", marginBottom: 10 },
  missingTitle: { color: "#ae6200", fontSize: 13, fontWeight: "800 !important" },
  detailTabsWrap: { borderBottom: "1px solid #e9eef0", padding: "0 22px" },
  detailTabs: {
    minHeight: 42,
    "& .MuiTab-root": { minHeight: 42, textTransform: "none", fontWeight: 700, fontSize: 13, color: "#64748b" },
    "& .Mui-selected": { color: "#087b59 !important" },
    "& .MuiTabs-indicator": { backgroundColor: "#087b59" },
  },
  detailGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 10, marginBottom: 16 },
  detailItem: { padding: "10px 12px", borderRadius: 8, background: "#f7f9fa", border: "1px solid #edf1f3" },
  detailLabel: { color: "#64748b", fontSize: 11, fontWeight: "700 !important", textTransform: "uppercase", letterSpacing: 0.4 },
  detailValue: { color: "#15253b", fontSize: 14, fontWeight: "700 !important", marginTop: 4 },
  detailForm: {
    display: "grid !important", gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  detailActions: { display: "flex", justifyContent: "flex-end", marginTop: 16, "& .MuiButton-root": { width: "auto", padding: "8px 18px" } },
  dialogLoader: { display: "flex", justifyContent: "center", padding: 32 },
  emptyText: { color: "#778596", fontSize: 14, textAlign: "center", padding: 24 },
  timeline: { display: "flex", flexDirection: "column", gap: 14, padding: "4px 0" },
  timelineItem: { display: "flex", gap: 12, alignItems: "flex-start" },
  timelineDot: { width: 10, height: 10, flex: "0 0 10px", marginTop: 5, borderRadius: "50%", background: "#087b59", boxShadow: "0 0 0 4px #e2f5ec" },
  timelineTitle: { color: "#15253b", fontSize: 14, fontWeight: "700 !important" },
  timelineMeta: { color: "#64748b", fontSize: 12.5, lineHeight: 1.5 },
  saveButton: { width: "100%", marginTop: 2, minHeight: 38, color: "#fff !important", backgroundColor: "#087b59 !important", borderRadius: 7, textTransform: "none", fontWeight: 700, fontSize: 12, boxShadow: "none", "& .MuiSvgIcon-root": { fontSize: 16 }, "&:hover": { backgroundColor: "#06694c !important", boxShadow: "none" } },
}));

export default useStyles;
